import { render, staticRenderFns } from "./manage-asset.vue?vue&type=template&id=85b8006e&scoped=true&"
import script from "./manage-asset.vue?vue&type=script&lang=ts&"
export * from "./manage-asset.vue?vue&type=script&lang=ts&"
import style0 from "./manage-asset.vue?vue&type=style&index=0&id=85b8006e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b8006e",
  null
  
)

export default component.exports